import { render, staticRenderFns } from "./ModalRenomear.vue?vue&type=template&id=e15c2ea2"
import script from "./ModalRenomear.vue?vue&type=script&lang=js"
export * from "./ModalRenomear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports